import React from "react";
import { Fade } from "@material-ui/core";
import DMTools from "components/DMTools/DMTools";

const DMToolsScreen = () => {
  return (
    <Fade in={true} style={{}} direction="left">
      <DMTools />
    </Fade>
  );
};

export default DMToolsScreen;
